export const appStateClientId = state => state.clientId;

// need check if this getters are necessary
export const getLoggedinUser = state => state.loggedinUser;
export const getStudy = state => state.newStudy;
export const getNewQuestion = state => state.newQuestion;
export const getSelectedQuestion = state => state.selectedQuestion;
export const getSurveyDetails = state => state.surveyDetails;
export const getSelectedFeatures = state => state.selectedFeatures;
export const getAddedConsentSection = state => state.addedConsentSection;
export const getAddedConsentQuiz = state => state.addedConsentQuiz;
export const getUpdatedProfileData = state => state.updatedProfileData;
export const getSchedulerObjData = state => state.schedulerObj;
export const getSurveyQuestionsData = state => state.surveyQuestions;
export const getSignatureStatus = state => state.signatureStatus;
export const getSignatureData = state => state.signatureData;
export const getCancelAssociationEditing = state => state.cancelAssociationEditing;
export const getTelehealthVisitObjData = state => state.telehealthVisitObj;
export const getVideoCallStatus = state => state.videoCallStatusValue;
export const getTelehealthAppointmentDuration = state => state.telehealthAppointmentDuration;
export const getAddedOptionalConsentSection = state => state.addedOptionalConsentSection;
export const getAddedOptionalConsentQuiz = state => state.addedOptionalConsentQuiz;

export const getStaticUrl = state => state.staticUrl;
export const getIsPublishDisable = state => state.isPublishDisabled;
export const getIsPreviewDisable = state => state.isPreviewDisabled;
export const getPublishTab = state => state.isPublishTab;
export const getIsRwebPreviewDisable = state => state.getIsRwebPreviewDisable;

export const getActivityRows = state => state.activityRows;
export const getActivityDetails = state => state.activityDetails;
export const getActivityQuestionsData = state => state.activityQuestions;
export const getNewActivityQuestion = state => state.newActivityQuestion;
export const getActivitySelectedQuestion = state => state.selectedActivityQuestion;
export const getLastModifiedActivityQuestion = state => state.lastModifiedActivityQuestion;
export const getBase64SignatureData = state => state.base64SignatureData;
export const getBase64InitialData = state => state.base64InitialData;

/** Participants Portal - START */
export const getParticipantsPortalGlobalElements = state => state.participantsPortalGlobalElements;
export const getParticipantsPortalConfig = state => state.participantsPortalConfig;
export const getParticipantsPortalLanguageTranslation = state => state.participantsPortalLangageTranslation;
export const getParticipantsPortalLanguages = state => state.participantsPortalLangages;
export const getParticipantsPortalStrings = state => state.participantsPortalStrings;
export const getParticipantsPortalBitriseData = state => state.participantsPortalBitriseData;
export const getParticipantsPortalStudyData = state => state.participantsPortalStudyData;
export const getParticipantSelectedActivity = state => state.participantsSelectedActivity;
export const getParticipantAdherences = state => state.participantAdherences;
export const getParticipantTaskSchedules = state => state.participantTaskSchedules;
export const getParticipantStudyTaskSchedules = state => state.participantStudyTaskSchedules;
export const getParticipantCountries = state => state.participantsCountries;
export const getParticipantLanguages = state => state.participantsLanguages;
export const getParticipantStudyVideos = state => state.participantsStudyVideos;
export const getParticipantPortalConsentData = state => state.participantsPortalConsentData;
export const getParticipantDetails = state => state.participantsPortalDetails;
export const getParticipantTelehealthVideoCallDetails = state => state.participantsTelehealthVideoCallDetails;
export const getParticipantsAppointmentStatus = state => state.participantsAppointmentStatus;
export const getParticipantsActivityTranslation = state => state.participantsActivityTranslation;
export const getSelectedActivity = state => state.selectedActivity;

/** Participants Portal - END */

export const awsCognitoAuthentication = state => state.awsCognitoAuthentication;
export const pwebCognitoAuthentication = state => state.pwebCognitoAuthentication;
export const getCSSRActivityLanguages = state => state.activityCSSRLangages;
export const ssoLoginURL = state => state.ssoLoginURL;
export const ssoPoolClient = state => state.ssoPoolClient;
/** Dynamic Activity Scheduling - Start */
export const getConstantDynamicActivitySchedulesData = state => state.constantDynamicActivitySchedulesData;
export const getDynamicActivitySchedules = state => state.dynamicActivitySchedulesData;
export const getDynamicActivityScheduleForEditing = state => state.editSelectedDynamicActivityScheduleData;
export const getConfiguredTriggersData = state => state.configuredTriggersData;
export const getConfiguredActionsData = state => state.configuredActionsData;
export const getDynamicSchedulingServiceData = state => state.dynamicSchedulingService;
/** Dynamic Activity Scheduling - End */
export const getDateRangeView = state => state.isDateRangeEnabled;
export const getStudyToggledFeatures = state => state.studyToggledFeatures;
export const multiFactorAuthEnabled = state => state.multiFactorAuthEnabled;
export const siteDetailsData = state => state.siteDetailsData;
export const getWebSocketServiceData = state => state.webSocketServiceData;
/** AWS AppConfig Feature Flags - Start */
export const getIsFeatureFlagEnabled = state => (featureKey, clientId) => {
  const flag = state.featureFlags[featureKey];
  
  if (flag && flag.enabled) { // if flag exists and feature is enabled
    // check if customer is enabled
    if (flag.customers && Array.isArray(flag.customers)) {
      return flag.customers.length === 0 || flag.customers.includes(clientId);
    } else {
      // customers is undefined
      return true;
    }
  }
  
  return false;
}
/** AWS AppConfig Feature Flags - End */